import type { App } from 'vue';
import { createGtm } from '@gtm-support/vue-gtm';
import type { Router } from 'vue-router';
import { DeployEnv, SLD, Site } from '@patsnap-utils/biz'

const REGION: DeployEnv = new Site({ sld: SLD.EUREKA }).env;

export const GtmPlugin = {
    install(app: App, router: Router, id?: string) {
        if (!router) return;
        const queryParams = [DeployEnv.QA, DeployEnv.STAGE].includes(REGION)
            ? {
                gtm_auth: '8DXn90HL4Cs9q2B2FcbkxA',
                gtm_preview: 'env-92',
                gtm_cookies_win: 'x',
            }
            : undefined;
        if ([DeployEnv.US, DeployEnv.EU, DeployEnv.QA, DeployEnv.STAGE].includes(REGION)) {
            app.use(createGtm({
                id: id || 'GTM-PRDLLN6',
                queryParams,
                vueRouter: router, // 传入 router 实例，GTM 会自动同步路由变化
                trackOnNextTick: true,
                ignoredViews: [],
                defer: true, // 如果需要延迟加载脚本可以设为 true
                compatibility: false, // 如果使用 Vue 3 设为 false
                enabled: true, // 生产环境可以动态控制开启/关闭
                debug: [DeployEnv.QA, DeployEnv.STAGE].includes(REGION), // 开发环境下开启调试模式，上线前记得改为 false
            }));
        }
    },
};
